module.exports = __webpack_public_path__ + "img/BR.59c18a07.svg";